export class FileInput {
  fileNode: HTMLElement | null = null
  fileContainerNode: HTMLElement | null = null
  inputNode: HTMLInputElement
  textNode: HTMLElement | null = null
  previewContainerNode: HTMLElement | null = null
  uploadButtonNode: HTMLButtonElement | null = null
  deleteIconNode: HTMLElement | null = null
  accepedtFileTypes: string[]
  messageNode: HTMLElement | null = null
  maxFileSize: number | null = null
  messageSpanNode: HTMLElement | null = null

  constructor (fileNode: HTMLElement) {
    this.fileNode = fileNode
    this.fileContainerNode = this.fileNode.querySelector('[data-ui-el="nfb-form-file-container"]') as HTMLElement
    this.inputNode = this.fileNode.querySelector('input') as HTMLInputElement
    this.textNode = this.fileNode.querySelector('span') as HTMLElement
    this.previewContainerNode = this.fileNode.querySelector('[data-ui-el="nfb-form-file-preview"]')
    this.uploadButtonNode = this.fileNode.querySelector('[role="button"]')
    this.deleteIconNode = this.fileNode.querySelector('[data-ui-el="nfb-delete-icon"]')
    this.messageNode = this.fileNode.querySelector('[data-ui-el="nfb-form-message"]')
    this.messageSpanNode = this.messageNode!.querySelector('span')
    this.maxFileSize = Number(this.fileContainerNode.dataset.maxFileSize)

    this.accepedtFileTypes = this.inputNode.accept.split(', ')
    this.messageSpanNode!.textContent = (this.messageNode?.dataset.formDefaultMessage !== undefined) ? this.messageNode?.dataset.formDefaultMessage : null

    this.uploadButtonNode?.addEventListener('click', () => {
      this.inputNode?.click()
    })

    this.uploadButtonNode?.addEventListener('keydown', () => {
      this.inputNode?.click()
    })

    this.deleteIconNode?.addEventListener('click', this.removeFile)

    this.inputNode.addEventListener('change', this.onInputChange)
    this.inputNode.addEventListener('keydown', this.onInputKeydown)
    this.previewContainerNode?.addEventListener('keydown', this.onPreviewKeydown)
  }

  onPreviewKeydown = (event: KeyboardEvent): void => {
    const key: string = event.key

    switch (key) {
      case 'Enter':
        if (this.fileContainerNode!.dataset.fileIsUploaded === 'true') {
          this.removeFile()
          event.preventDefault()
          event.stopPropagation()
        }
        break
      default:
        break
    }
  }

  removeFile = (): void => {
    this.inputNode.files = (new DataTransfer()).files
    this.textNode!.textContent = ''
    this.fileContainerNode!.dataset.fileIsUploaded = 'false'
    this.uploadButtonNode!.classList.remove('nfb-form__file-button--disabled')
  }

  onInputKeydown = (event: KeyboardEvent): void => {
    const key: string = event.key

    switch (key) {
      case 'Enter':
        this.onInputChange()
        event.preventDefault()
        event.stopPropagation()
        break
      default:
        break
    }
  }

  onInputChange = (): void => {
    if (this.validateFile(this.inputNode.files![0])) {
      this.messageSpanNode!.textContent = (this.messageNode?.dataset.formDefaultMessage !== undefined) ? this.messageNode?.dataset.formDefaultMessage : null

      this.textNode!.textContent = this.inputNode.files![0].name
      this.fileContainerNode!.dataset.fileIsUploaded = 'true'
      this.uploadButtonNode!.classList.add('nfb-form__file-button--disabled')
      this.fileNode!.classList.remove('nfb-form__element-container--invalid')
      this.previewContainerNode!.classList.remove('nfb-form__file-preview-container--invalid')
    } else {
      this.messageSpanNode!.textContent = (this.messageNode?.dataset.formErrorMessage !== undefined) ? this.messageNode?.dataset.formErrorMessage : null

      this.fileNode!.classList.add('nfb-form__element-container--invalid')
      this.previewContainerNode!.classList.add('nfb-form__file-preview-container--invalid')
      this.removeFile()
    }
  }

  validateFile = (file: File): boolean => {
    if (!this.accepedtFileTypes.includes(file.type)) {
      this.messageNode!.dataset.formErrorMessage = this.messageNode?.dataset.formFileTypeError
      return false
    }
    if (this.maxFileSize !== null && file.size > this.maxFileSize) {
      this.messageNode!.dataset.formErrorMessage = this.messageNode?.dataset.formFileSizeError
      return false
    }
    return true
  }
}
